import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearBonusesAction } from "../bonusesActions.js";
import { BonusContext } from "../bonusContext.js";
import { useWelcomeBonusAvailableTimer } from "../bonusesHooks.js";
import { makeSelectAppLoggedIn } from "../../../app/appSelectors.js";
import { getWelcomeBonusAvailable } from "../bonusesSelectors";

const BonusProvider = ({children}) => {
    const dispatch = useDispatch();
    const welcomeBonusAvailable = useSelector(getWelcomeBonusAvailable);
    const loggedIn = useSelector(makeSelectAppLoggedIn());

    const {secondsLeftForFullBonus: bonusAvailableSecondsLeft} =
        useWelcomeBonusAvailableTimer(welcomeBonusAvailable?.secondsLeft);
    const percents = welcomeBonusAvailable?.percents || [];
    const bonusAvailablePercent = bonusAvailableSecondsLeft ? percents[0] : percents[1];
    const isHasBonusAvailable = !!welcomeBonusAvailable;

    useEffect(() => {
        if (!loggedIn) {
            dispatch(clearBonusesAction());
        }
    }, [dispatch, loggedIn]);

    return (
        <BonusContext.Provider value={{bonusAvailablePercent, bonusAvailableSecondsLeft, isHasBonusAvailable}}>
            {children}
        </BonusContext.Provider>
    )
}

export default BonusProvider;
